import { Select } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import SelectBox from '../../components/inputs/selectbox/SelectBox';
import { UserInterface } from '../../interfaces/UserInterface';

type OptionType = { label: any; value: string };

type props = {
  onSelect: (value: string, option: OptionType | OptionType[]) => void;
  users: UserInterface[];
  defaultValue?: string;
  value?: string;
  error: '' | 'error' | 'warning' | undefined;
  disabled?: boolean;
  mode?: string;
};

const SelectUser: FC<props> = ({
  onSelect,
  users,
  defaultValue,
  error,
  disabled,
  mode = 'single',
  value,
}) => {
  const { t } = useTranslation();

  if (mode === 'single') {
    return (
      <SelectBox
        onChange={onSelect}
        defaultValue={defaultValue}
        value={value}
        options={users}
        search={true}
        notFoundText={t('Geen gebruiker gevonden')}
        disabled={disabled}
      />
    );
  }

  return (
    <Select
      mode="multiple"
      allowClear
      style={{ width: '100%' }}
      placeholder={t('Selecteer gebruiker')}
      onChange={onSelect}
      value={value}
      options={users}
      disabled={disabled}
      status={error}
    />
  );
};

export default SelectUser;
